import { LOGINSTAT } from "../../actions/login/";

const INITIALVALUES = {
  loginstat: false
};

export default function(state = INITIALVALUES, action){
  switch (action.type) {
    case LOGINSTAT:
    return { loginstat: action.payload };
    default:
  }

  return state;
}
